import BasePropertyView     from 'BasePropertyView.js';
import { Model }            from 'backbone';
import Template             from 'behaviors/properties/main/connect.ejs';
import SearchTemplate       from 'behaviors/properties/main/connect-search.ejs';
import restService          from 'RestService';
import listService          from 'ListService.js';
import constants            from 'Constants.js';
import util                 from 'util/Util.js'
import selectFieldModalView from 'common-views/SelectFieldModalView.js';
import userService          from 'UserService.js';
import widgetUtil           from 'util/WidgetUtil.js';
import undoService      from 'UndoService';

//=====================================================================
//
// An instance of this view represents the connect behavior script.
//
// Casey Justus, May 15, 2016
//
//=====================================================================
const textToDisplayConnectionsDefaultOption = 'Please select one connection';
const textToDisplayActionsDefaultOption = 'Please select one action';
const textToDisplayEmptyConnectionsDefaultOption = 'No connections available';
const textToDisplayEmptyActionsDefaultOption = 'No actions available';

class MainConnectView extends BasePropertyView {

    initialize(opts) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.ConnectionType = '';
       
        if (opts.config) {
            this.template = SearchTemplate;
        }

        this.events = {
            'change input[type=checkbox]'       : 'updateCheckAttributes',
            'change select'                     : 'updateSelect',
            'click button[name=refreshConnections]': 'refreshConnections',
            'click button[name=refreshActions]'    : 'refreshActions',
            'change input[type=text], textarea' : 'updateAttributes',
            'blur textarea, input[type=text]'   : 'lostFocus',
            'focus textarea, input[type=text]'  : 'getFocus',
            'click #connectCustomUrlSearch'     : 'showSelectModal'
        };

        if (this.model.get('fielddynamicurl')) {
            const id = this.model.get('fielddynamicurl');
            const obj = listService.getObject(listService.cleanId(id));
            if (obj) {
                let name = obj ? obj.model.get('name') : '';
                this.model.set('ValueOfAField', name, {silent:true});
            }
        } else {
            this.model.set('valueOfAField', '', {silent: true});
            this.model.set('customURL', 'false', {silent: true});
            this.model.set('dynamicurl', 'off', {silent: true});
        }

        if(this.model.get("message")){
            let propVal = this.model.get("message");
            propVal = propVal.replace(/<br>/ig, '&#10;');
            propVal = propVal.replace(/\\'/g, "'").replace(/&#39;/g, "'");
            this.model.set("message", propVal, {silent:true});
        }

        this.loadDataFromRequest();
        this.pendingClickConnection = false;

        return this;
    }

    showSelectModal(ev) {
        ev.preventDefault();
        const factoryKey= 'modal';
        var sfModal = new selectFieldModalView({model: new Model(), mode: 'field', target:this.model.get('factoryKey')});
        sfModal.render().then((selectedField)=>{
            this.model.set('fielddynamicurl', selectedField.id, {silent:true});
            this.model.set('ValueOfAField', selectedField.name);

            $('#connectCustomUrl').val(selectedField.name);
        }).catch(err => console.log(err));
    }

    checkFeatures() {
        const features = userService.getUserFeatures();

        // SF Feature and WS Connection Type
        if (features.SalesForce && this.ConnectionType === '3') {
            // enabled controls
            $('#customURL').removeAttr('disabled');
            $('#connectCustomUrl').removeAttr('disabled');
            $('#connectCustomUrlSearch').prop('disabled', '');
            $(`input[name='dynamicurl']`).prop('disabled', '');
        } else {
            $('#customURL').attr('disabled', true);
            $('#connectCustomUrl').attr('disabled', true);
            $('#connectCustomUrlSearch').prop('disabled', true);
            $(`input[name='dynamicurl']`).prop('disabled', true);
        }
    }

    loadDataFromRequest() {
        this.model.set('gridData', [], {silent: true});
        this.model.set('gridData2', [], {silent: true});
        const sendParameters = this.model.attributes.Request.Send.parameter;
        const receiveParameters = this.model.attributes.Request.Receive.parameter;
        let gridData = this.model.get('gridData');
        let gridData2 = this.model.get('gridData2');
        let objName = '';

        if (sendParameters) {
            for (let sendParameter of sendParameters) {
                objName = '';
                if (sendParameter) {
                    if (sendParameter._value) {
                        const id = sendParameter._value;
                        const obj = listService.getObject(listService.cleanId(id));
                        if (obj && !constants.CONTROL_CAPTION_VALUE_KEYS.contains(obj.model.get('factoryKey'))){                            
                            objName = obj ? obj.model.get('name') : '';
                        }else{                            
                            objName = listService.determineFieldName(id);
                            objName = objName ? objName : '';
                        }
                    }

                    let newRow = {
                        'search': util.isTrue(sendParameter._show) ? 'selected' : '',
                        'name': sendParameter._name,
                        'source': sendParameter._type === 'expression' ? '[Formula]' : objName,
                        'formula': sendParameter._type === 'expression' ? 'selected' : '',
                        'dataType': sendParameter._dataType || ''
                    };
                    gridData.push(newRow);
                }
            }
            this.model.set('gridData', gridData, {silent: true});
        }

        if (receiveParameters) {
            for (let receiveParameter of receiveParameters) {
                objName = '';
                if (receiveParameter) {
                    if (receiveParameter._value) {
                        const id = receiveParameter._value;
                        const obj = listService.getObject(listService.cleanId(id));
                        if (obj && (!constants.CONTROL_CAPTION_VALUE_KEYS.contains(obj.model.get('factoryKey'))
                            || (receiveParameter._type === 'itemsValue' || receiveParameter._type === 'itemsCaption' ))){
                            objName = obj ? obj.model.get('name') : '';
                        }else{                            
                            objName = listService.determineFieldName(id);
                            objName = objName ? objName : '';
                        }
                    }

                    const type = receiveParameter._type;

                    let newRow = {
                        'show': util.isTrue(receiveParameter._show) ? 'selected' : '',
                        'name': receiveParameter._name,
                        'target': objName,
                        'caption': (type === 'itemsCaption' || type === 'items') ? 'selected' : '',
                        'value': (type === 'itemsValue' || type === 'items') ? 'selected' : '',
                        'select': receiveParameter._emptyDefaultItem === 'true' ? 'selected' : ''
                    };
                    gridData2.push(newRow);
                }
            }
            this.model.set('gridData2', gridData2, {silent: true});
        }
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.value;
        let oldVal = this.model.get(propName);

        if(propName.toLowerCase() === "message"){
            propVal = propVal.replace(/'/g, '&#39;');//PF-5550 Replace apostrophes
        }

        if (oldVal.toString() !== propVal.toString()) {
           this.model.set( propName, propVal, {silent:true} );

           undoService.add({
                undo: () => {
                    this.model.set( propName, oldVal, {silent:true} );
                    this.render();
                },
                redo:() => {
                    this.model.set( propName, propVal, {silent:true} );
                    this.render();
                }
            }, constants.UNDO_PROP_CHANGE);
        }
    }

    updateSelect(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const optionSelected=$(`select[name='${propName}'] option[value='${propVal}']`);
        switch (propName) {
            case 'connection':
                this.cleanTable();
                this.initTable();
                // TODO
                let gridData = this.model.get('gridData');
                this.initTable(constants.PROP_MAIN_TABLE2, gridData.length);
                this.fillActionData(propVal);
                this.ConnectionType = $(optionSelected).attr('dataValue');
                this.model.set('connectionName',$(optionSelected).text(),{silent:true});
                this.model.set('connectionId',propVal,{silent:true});
                if (propVal !== 'none') {
                    this.model.set('widgetText', widgetUtil.getWidgetText(this.model), {silent:true} );
                } else {
                    this.model .set('widgetText', '', {silent:true} );
                }
                let widget = listService.getBehaviorObject(this.model.attributes.id);
                widget.rerender();

                this.checkFeatures();

                break;
            case 'action':
                let connectionId = $('select[name="connection"]').val();
                this.fillParametersData(propVal, connectionId);
                this.model.set('actionName',$(optionSelected).text(),{silent:true});
                this.model.set('actionId',propVal,{silent:true});

                break;
        }
        //this.model.set( propName, propVal );
    }

    refreshConnections() {
        if (!this.pendingClickConnection) {
            this.pendingClickConnection = true;
            $('select[name="connection"]').empty();
            $('select[name="connection"]').prepend($('<option></option>').html('Loading...'));
            restService.getConnections().then((connections)=> {
               $('select[name="connection"]').empty();
                connections.push({"@ConnectionId":"meta","@Name":"System Meta Data", "@Type":"99", "hasChildren":"False"});
                window.sessionStorage.setItem('pfConnections', JSON.stringify(connections));
                this.updateConnectionInfo(connections, false);
                this.pendingClickConnection = false;
            }, function(err) {
                this.pendingClickConnection = false;
                // Expected error on multiple callings
            });
        }
    }

    updateConnectionInfo(connections, refreshActionsToo) {
            const connectionSelect = $('select[name="connection"]');
            connectionSelect.empty();
            const actionSelect = $('select[name="action"]');

            if ($.isEmptyObject(connections)) {
                util.appendOptionToSelect(connectionSelect, 'none', textToDisplayEmptyConnectionsDefaultOption, true);
                actionSelect.empty();
                util.appendOptionToSelect(actionSelect, 'none', textToDisplayEmptyActionsDefaultOption, true);
            }
            else {
                util.appendOptionToSelect(connectionSelect, 'none', textToDisplayConnectionsDefaultOption, true);

                for (let connection of connections) {
                    util.appendOptionToSelect(connectionSelect, connection['@ConnectionId'], connection['@Name'], false,
                                              connection['@Type'] );
                }
            }

            // If there was already a connection saved into the model, must be selected on render.
            const connId = this.model.get('connectionId')
            if(connId){
                const optionSelected=$(`select[name="connection"] option[value="${this.model.get('connectionId')}"]`);
                optionSelected.prop('selected',true);
                this.ConnectionType = $(optionSelected).attr('dataValue');

                if ( refreshActionsToo ) {
                    actionSelect.empty();
                    this.fillActionData(connId, false);
                }
            }
    }

    refreshActions() {
        $('select[name="action"]').empty();
        $('select[name="action"]').prepend($('<option></option>').html('Loading...'));
        const connectionId = $('select[name="connection"]').val();
        this.fillActionData(connectionId, true);
    }

    fillConnectionData() {
        const connections =  JSON.parse(window.sessionStorage.getItem('pfConnections'));
        connections.push({"@ConnectionId":"meta","@Name":"System Meta Data", "@Type":"99", "hasChildren":"False"});
        this.updateConnectionInfo(connections, true);
    }

    fillActionData(connectionId, refresh = false) {

        // PF-4587: To avoid loading data we don't need at this stage
        // (When loading the behavior canvas for the first time)
       // if ($(event.target).parent().hasClass('behavior-selector')) {
       //     return;
       // }

        // PF-4587: Make sure we don't request for the same data more than once
        if (_.includes(listService.promiseInProgress, connectionId)) {
            return;
        }

        if (connectionId !== "meta"){
                listService.promiseInProgress = connectionId;
                restService.getActionsByConnectionId(connectionId).then( actions => {
                        const select = $('select[name="action"]');
                        select.empty();
         
                        if ($.isEmptyObject(actions)) {
                            util.appendOptionToSelect(select, 'none', textToDisplayEmptyActionsDefaultOption, true);
                        }
                        else {
                            // If there was already an action saved into the model, must be selected on render.
                            if(this.model.get('actionId')){
                                for (let action of actions) {
                                    util.appendOptionToSelect(select, action['@ActionId'], action['@Name']);
                                }
                                $(`select[name='action'] option[value='${this.model.get('actionId')}']`).prop('selected',true);
                                util.prependOptionToSelect(select, 'none', textToDisplayActionsDefaultOption, false);
                            }
                            else{
                                for (let action of actions) {
                                    util.appendOptionToSelect(select, action['@ActionId'], action['@Name']);
                                }
                                util.prependOptionToSelect(select, 'none', textToDisplayActionsDefaultOption, true);
                            }
                        }
                        const actionId = this.model.get('actionId');
                        if (actionId) {
                            $(`select[name="action"] option[value="${this.model.get('actionId')}"]`).prop('selected',true);
                        }
                    }).then(()=>{
                        // This clears any formula!
                        const actionId = this.model.get('actionId');
                        if ( refresh && !util.isEmpty(actionId) ) {
                            this.fillParametersData(actionId, connectionId);
                        }
                    }, function(err) {
                        // Expected error on multiple callings
                        if (err.CODE !== '2') {
                            console.log(`fillActionData getActionsByConnectionId`, err);
                        }
                    });
     }else{
          let select = $('select[name="action"]');
          select.empty();
          const actions = constants.META_DATA_ACTIONS;
          if(this.model.get('actionId')){
              for (let action of actions) {
                  util.appendOptionToSelect(select, action['@ActionId'], action['@Name']);
              }
              $(`select[name='action'] option[value='${this.model.get('actionId')}']`).prop('selected',true);
              util.prependOptionToSelect(select, 'none', textToDisplayActionsDefaultOption, false);
          }
          else{
             for (let action of actions) {
                  util.appendOptionToSelect(select, action['@ActionId'], action['@Name']);
              }
              util.prependOptionToSelect(select, 'none', textToDisplayActionsDefaultOption, true);
         }
         let actionId =this.model.get('actionId');
         if (actionId) {
                   $(`select[name="action"] option[value="${this.model.get('actionId')}"]`).prop('selected',true);
          }
          if ( refresh && !util.isEmpty(actionId) ) {
            this.fillParametersData(actionId, connectionId);
         }
     }

    }

    cleanTable() {


        //Cleaning parameters
        this.model.attributes.Request.Send.parameter = [];
        this.model.attributes.Request.Receive.parameter = [];

        // Cleaning Actions Ids when a new connection its selected.
        this.model.set('actionId','',{silent:true});
        this.model.set('actionName','',{silent:true});

        this.deleteGridRows();
    }

    deleteGridRows() {
        this.model.set('gridData', [], {silent: true});
        this.model.set('gridData2', [], {silent: true});

        util.deleteGridRows(constants.PROP_MAIN_TABLE);
        util.deleteGridRows(constants.PROP_MAIN_TABLE2);
    }

    initTable(tableId, offset) {
        let newRow = {
            'name': '',
            'source': '',
            'formula': '',
            'isDefault': true
        };

        let _offset = 0;
        if (typeof offset !== 'undefined'){
            _offset = offset;
        }

        for (let i = _offset; i < 6; i++) {
            if (typeof tableId === 'undefined') {
                $(constants.PROP_MAIN_TABLE).addRowData(i, newRow);
                $(constants.PROP_MAIN_TABLE2).addRowData(i, newRow);
            } else {
                $(tableId).addRowData(i, newRow);
            }
        }
    }

    addFormGUIDSendParam(){
        let gridData = this.model.get('gridData');
        if (!gridData){
            gridData = [];
        }

        let newRow = {
            'name': constants.CONNECTION_FORM_FORM_INSTANCE_GUID_PARAM_NAME,
            'source': '',
            'formula': '',
            'isDefault': ''
        };

        $(constants.PROP_MAIN_TABLE).addRowData((gridData.length), newRow);
        gridData.push(newRow);

        return { _id: constants.CONNECTION_FORM_FORM_INSTANCE_GUID_PARAM_ID, _name: constants.CONNECTION_FORM_FORM_INSTANCE_GUID_PARAM_NAME, _type: 'field', _value: '', _show: 'false', _emptyDefaultItem: 'false' };
    }

    fillParametersData(actionId, connectionId) {

        const prevSendParameters = this.model.get('gridData');
        const prevReturnParameters = this.model.get('gridData2');

        const prevRequest = this.model.get('Request');

        this.deleteGridRows();
        let RequestSendParams = [];
        let RequestReceiveParams = [];
        let gridData = [];
        if (actionId === 'none'){
            this.initTable();
            return;
        }

        if (connectionId !== 'meta') {
            restService.getParametersByActionIdAndConnectionId(actionId, connectionId).then((parameters) => {
                // Adding rows on the Jquery Grid for send parameters table.
                if (typeof parameters.sendParameters !== 'undefined') {

                    if (parameters.actionType === constants.CONNECTION_FORMS_UPDATE) {
                        RequestSendParams.push(this.addFormGUIDSendParam());
                    }

                    for (let sendParameter of parameters.sendParameters) {
                        if (typeof sendParameter !== 'undefined') {
                            gridData = this.model.get('gridData');

                            const existingParam = prevSendParameters.find(param => param.name === sendParameter._name);

                            let newRow = existingParam !== undefined ? existingParam : {
                                'name': sendParameter._name,
                                'source': '',
                                'formula': '',
                                'isDefault': '',
                                'dataType': sendParameter._dataType || ''
                            };

                            $(constants.PROP_MAIN_TABLE).addRowData((gridData.length), newRow);

                            gridData.push(newRow);
                            const prevSendRequest = prevRequest.Send.parameter.find(param => param._id === sendParameter._id);
                            let newParam = prevSendRequest !== undefined
                                    ? prevSendRequest : { _id: sendParameter._id,
                                                            _name: sendParameter._name,
                                                            _type: 'field', _value: '',
                                                            _show: 'false',
                                                            _emptyDefaultItem: 'false',
                                                            _dataType: sendParameter._dataType
                                                        };

                            RequestSendParams.push(newParam);
                        }
                    }
                    // Updating grid model
                    this.model.set('gridData', gridData, { silent: true });
                    this.initTable(constants.PROP_MAIN_TABLE, gridData.length);
                }

                // Adding rows on the Jquery Grid for send parameters table.
                if (typeof parameters.returnParameters !== 'undefined') {
                    let gridData = [];
                    for (let returnParameter of parameters.returnParameters) {
                        if (typeof returnParameter !== 'undefined') {
                            gridData = this.model.get('gridData2');

                            const existingParam = prevReturnParameters.find(param => param.name === returnParameter._name);

                            let newRow = existingParam !== undefined ? existingParam : {
                                'name': returnParameter._name,
                                'target': '',
                                'caption': '',
                                'value': '',
                                'select': '',
                                'isDefault': ''
                            };
                            $(constants.PROP_MAIN_TABLE2).addRowData((gridData.length), newRow);

                            gridData.push(newRow);

                            const prevReceiveRequest = prevRequest.Receive.parameter.find(param => param._id === returnParameter._id);
                            let newParam = prevReceiveRequest !== undefined
                                        ? prevReceiveRequest :
                                                { _id: returnParameter._id,
                                                  _name: returnParameter._name,
                                                  _type: returnParameter._type,
                                                  _value: '', _show: 'false',
                                                  _emptyDefaultItem: 'false'
                                                };

                                RequestReceiveParams.push(newParam);
                        }
                    }
                    // Updating grid model
                    this.model.set('gridData2', gridData, { silent: true });
                    this.initTable(constants.PROP_MAIN_TABLE2, gridData.length);
                }

                this.model.attributes.Request.Send.parameter = RequestSendParams;
                this.model.attributes.Request.Receive.parameter = RequestReceiveParams;

                //Restoring the actionId, this is for the scenario when refreshing Action's select
                if (this.model.get('connectionId') === connectionId && actionId && actionId !== ''){
                    this.model.set('actionId', actionId, {silent: true});
                }
            }).catch((error) => {
                console.log('The following error has ocurred', error)
            });
        } else {
            let parameters;
            switch (actionId) {
                case 'users':
                    parameters = constants.META_USERS_PARAMETERS
                    break;
                case 'positions':
                    parameters = constants.META_POSITIONS_PARAMETERS
                    break;
                case 'usergroups':
                    parameters = constants.META_USER_GROUPS_PARAMETERS
                    break;
            }
            // Adding rows on the Jquery Grid for send parameters table
            for (let sendParameter of parameters.sendParameters) {
                if (typeof sendParameter !== 'undefined') {
                    gridData = this.model.get('gridData');
                    let newRow = {
                        'name': sendParameter._name,
                        'source': '',
                        'formula': '',
                        'isDefault': '',
                        'dataType': sendParameter._dataType || ''
                    };
                    $(constants.PROP_MAIN_TABLE).addRowData((gridData.length), newRow);

                    gridData.push(newRow);

                    RequestSendParams.push({ _id: sendParameter._id, _name: sendParameter._name, _type: 'field', _value: '', _show: 'false', _emptyDefaultItem: 'false' });
                }
            }
            // Updating grid model
            this.model.set('gridData', gridData, { silent: true });
            this.initTable(constants.PROP_MAIN_TABLE, gridData.length);

            // Adding rows on the Jquery Grid for return parameters table.
            for (let returnParameter of parameters.returnParameters) {
                if (typeof returnParameter !== 'undefined') {
                    gridData = this.model.get('gridData2');
                    let newRow = {
                        'name': returnParameter._name,
                        'target': '',
                        'caption': '',
                        'value': '',
                        'select': '',
                        'isDefault': ''
                    };
                    $(constants.PROP_MAIN_TABLE2).addRowData((gridData.length), newRow);

                    gridData.push(newRow);

                    RequestReceiveParams.push({ _id: returnParameter._id, _name: returnParameter._name, _type: returnParameter._type, _value: '', _show: 'false', _emptyDefaultItem: 'false' });
                }
            }
            // Updating grid model
            this.model.set('gridData2', gridData, { silent: true });
            this.initTable(constants.PROP_MAIN_TABLE2, gridData.length);

            this.model.attributes.Request.Send.parameter = RequestSendParams;
            this.model.attributes.Request.Receive.parameter = RequestReceiveParams;

            //Restoring the actionId, this is for the scenario when refreshing Action's select
            if (this.model.get('connectionId') === connectionId && actionId && actionId !== ''){
                this.model.set('actionId', actionId, {silent: true});
            }
        }
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.checked;

        this.model.set(propName, propVal);
    }

    render() {

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $("#connectSearchMessage").html(this.model.get("message"));

        let bShowError = util.isTrue(this.model.get('showError'));
        $(`input[name='showError']`).prop('checked', bShowError );

        // connect and search is usint dynamicurl field and connect is using customURL
        let bDynamicurl = util.isTrue(this.model.get('dynamicurl'));
        $(`input[name='dynamicurl']`).prop('checked', bDynamicurl );
        let bCustomURL = util.isTrue(this.model.get('customURL'));
        $(`input[name='customURL']`).prop('checked', bCustomURL );

        this.fillConnectionData();
        this.checkFeatures();

        this.delegateEvents();
        return this;
    }

}

export default MainConnectView;
